import React from 'react';
import { Divider as AntDivider, ConfigProvider } from 'antd';
import styles from './divider.module.scss';
import { colorPalette } from 'shared/constants';

/**
 * @typedef {import('antd').DividerProps
 *  & {
 *     className?: string
 * }} DividerProps
 */
const Divider = React.memo(
  /**
   * @param {DividerProps} props
   * @returns
   */
  function Divider({ dividerColor, ...props }) {
    return (
      <ConfigProvider
        theme={{
          components: {
            Divider: {
              colorSplit: dividerColor ?? colorPalette.neutral5,
            },
          },
        }}>
        <AntDivider className={styles.divider} {...props} />
      </ConfigProvider>
    );
  },
);

export { Divider };
